// Copyright 2019 Bik_krl
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export const CREATE_NEW_CUSTOMER = "CREATE_NEW_CRM";
export const CREATE_NEW_SUPPLIER = "CREATE_NEW_CRM";
export const CRM_IS_LOADING = "CRM_IS_LOADING";
export const CRM_MODAL = "CrmModal";
export const RESET_CRM_MESSAGE = "RESET_CRM_MESSAGE";
export const GET_ALL_CRM_CUSTOMER = "GET_ALL_CRM_CUSTOMER";
export const GET_ALL_CRM_SUPPLIER = "GET_ALL_CRM_SUPPLIER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const DELETE_SUPPLIER = "DELETE_SUPPLIER";
